import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

class productSummary extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateProductSummary);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateProductSummary);
  }

  /**
   * Updates the price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateProductSummary = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    //price
    const newPrice = event.detail.data.html.querySelector('product-summary [ref="summaryResaleValue"]');
    const currentPrice = this.querySelector('[ref="summaryResaleValue"]');
    if (!newPrice || !currentPrice) return;
    if (currentPrice.innerHTML !== newPrice.innerHTML) {
      currentPrice.replaceWith(newPrice);
    }
    // variant value
    const newVariantValue = event.detail.data.html.querySelector('product-summary [ref="summaryPerItems"]');
    const currentVariantValue = this.querySelector('[ref="summaryPerItems"]');
    if (!newVariantValue || !currentVariantValue) return;
    if (currentVariantValue.innerHTML !== newVariantValue.innerHTML) {
      currentVariantValue.replaceWith(newVariantValue);
    }
    const newSummaryPerItemValue = event.detail.data.html.querySelector('product-summary [ref="summaryPerItemValue"]');
    const currentSummaryPerItemValue = this.querySelector('[ref="summaryPerItemValue"]'); 
    const numberPerItemValue = newSummaryPerItemValue.innerHTML;
    if (!newSummaryPerItemValue || !currentSummaryPerItemValue) return;
    if (currentSummaryPerItemValue.innerHTML !== newSummaryPerItemValue.innerHTML) {
      currentSummaryPerItemValue.innerHTML = numberPerItemValue;
    }

  };
}

if (!customElements.get('product-summary')) {
  customElements.define('product-summary', productSummary);
}